import React, {Component, Fragment} from 'react';
import classNames from 'classnames';
import './AnalyticsReport.scss';
import {ApiGet} from "../../../shared/services/api-service";
import {analyticsColorScheme, scoreColors} from "./color-scheme";
import reportModel from '../../models/report';
import PhasesRow from "./report/PhasesRow";
import WeeksRow from "./report/WeeksRow";
import SequenceRow from "./report/SequenceRow";
import DatesRow from "./report/DatesRow";
import QuestionRow from "./report/QuestionRow";
// import * as XLSX from "../../../shared/services/xlsx.mjs";
import * as XLSX from "dep-xlsx-js-style";
import PhaseReport from "./report/PhaseReport";
import {minutesToFormatted} from "../reports/dynamic-form/TimeTrackingField";
import Tooltip from "../../../shared/ui/Tooltip";
import Modal from "../../../shared/ui/Modal";
import CustomForm from "../../../shared/components/form/CustomForm";
import {ApproveReportsForm} from "../../../shared/components/form/ApproveReports";
import {connect} from "react-redux";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import TimeAnalytics from "./TimeAnalytics";
import {ChooseRatingForm} from "../../../shared/components/form/ChooseRatingForm";
import PerformanceReport from "./report/PerformanceReport";
import {taskDelay} from "../../../shared/services/utils/utils";
import {getEvaluationCellValue, getEvaluationComments} from "./report/analyticsUtils";
import AnalyticsGrid from "./report/grid/AnalyticsGrid";
const HTMLtoDOCX = import('html-to-docx')

let style
class AnalyticsReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFullscreen: false,
      popupPosition: {},
      currentExport: null,
      currentPrint: null,
      currentPrintPerformanceReport: null,
      openedDay: null,
      isApproveReportsLoading: false,
      showApproveReportsDialog: false,
      showInlineComments: false,
      showUnderPerformanceReport: false,
      reportAnalyticsForPerformanceReport: null
    };

    this.afterPrint = this.afterPrint.bind(this)
  }

  toggleFullscreen() {
    this.setState({
      isFullscreen: !this.state.isFullscreen
    })
  }

  setPopupPosition(key, e) {
    this.setState({
      popupPosition: {
        ...this.state.popupPosition,
        [key]: {
          top: e.clientY,
          left: e.clientX
        }
      }
    })
  }

  getBackgroundColor(question, scale) {
    if (question.rating && this.props.reportType === 'rating') {
      if(question.ratingLabel && !question.isEvaluationRating) {
        return scoreColors[question.rating]
      }
      return analyticsColorScheme[question.scale || scale || this.props.departmentSettings.scale || 5][question.rating];
    } else {
      if(!question.timeSpend || question.timeSpend === 0) {
        return '#ccc'
      }

      return null
    }
  }

  getCellColor(question) {
    if (this.props.reportType === 'rating') {
      return question.rating ? '#fff' : '#000'
    }
    return '#000'
  }

  timeConvert(minutes) {
    var numOfHours = (minutes / 60);
    var hours = Math.floor(numOfHours);
    var numOfMinutes = (numOfHours - hours) * 60;
    var minutes = Math.round(numOfMinutes);

    if (hours > 0) {
      return hours + "h " + minutes + "m";
    }

    return minutes + "m";
  }

  getCellValue(question) {
    if (this.props.reportType === 'time-spend') {
      if (question.timeSpend) {
        return this.timeConvert(question.timeSpend);
      } else {
        return <span>0</span>
      }
    }

    if (question.isEvaluationRating) {
      return getEvaluationCellValue(question)
    }

    if (question.rating === 'acceptable') {
      return <span className="fa fa-check"/>;
    } else if (question.rating === 'unAcceptable') {
      return <span className="fa fa-minus"/>;
    } else if (question.rating) {
      return question.ratingLabel || question.rating;
    } else if (question.notObserved) {
      return <span>N.O.</span>
    } else {
      return <span>N.R.T</span>
    }
  }

  getAvgCellValue(avgField) {
    if (this.props.reportType === 'time-spend') {
      return this.timeConvert(avgField.timeSpendAvg)
    } else {
      return avgField.avgRating
    }
  }

  getAvgBackgroundColor(avgField) {
    if (this.props.reportType === 'time-spend') {
      if(avgField.timeSpendAvg === 0 || !avgField.timeSpendAvg) {
        return '#eee'
      }

      if(avgField.timeSpendAvg && avgField.timeSpendAvg !== 0)  {
        return '#eabf2e'
      }

      return null
    } else {
      return null
    }
  }

  getTotalTimeSpend(questions, avgMap, phaseGuid, weekNumber) {
    return this.props.filteredQuestions.reduce((total, question) =>
      total + (avgMap[`${phaseGuid}#${question}#${weekNumber}`] ? avgMap[`${phaseGuid}#${question}#${weekNumber}`].timeSpendAvg : 0), 0);
  }

  getPhaseTotalTimeSpend(questions, avgMap, phaseGuid) {
    return this.props.filteredQuestions.reduce((total, question) =>
      total + (avgMap[`${phaseGuid}#${question}#`] ? avgMap[`${phaseGuid}#${question}#`].timeSpendAvg : 0), 0);
  }

  getProgramTotalTimeSpend(questions, avgMap,) {
    return this.props.filteredQuestions.reduce((total, question) =>
      total + (avgMap[`#${question}#`] ? avgMap[`#${question}#`].timeSpendAvg : 0), 0);
  }

  openDay(reportHash, phaseGuid, week, day, numberOfReports) {
    if(numberOfReports < 2) {
      this.openReport(reportHash, 0)
    } else {
      if(this.state.openedDay) {
        this.setState({
          openedDay: null
        })
      } else {
        this.setState({
          openedDay: {
            phaseGuid,
            week,
            day,
          }
        })
      }
    }
  }

  openApproveReports(e, reports) {
    e.stopPropagation()
    e.preventDefault()
    this.reportsForApprove = reports;
    this.setState({
      showApproveReportsDialog: true
    })
  }
    approveReports(form) {

    let promises = Promise.all(this.reportsForApprove.map(r => {
      let approveType = null
      let report = reportModel({
        attributes: r,
        guid: r.reportGuid,
        type: r.type
      });

      if(report.getTypeHasApproval() && report.getCanApprove(this.props.userContext.scope)) {
        approveType = 'approvedOneAt'
      } else if(report.getTypeHasApproveTwo() && report.getCanApproveTwo(this.props.userContext.scope)) {
        approveType = 'approvedTwoAt'
      } else if(report.getTypeHasApproveThree() && report.getCanApproveThree(this.props.userContext.scope)) {
        approveType = 'approvedThreeAt'
      } else if(report.getTypeHasApproveFour() && report.getCanApproveFour(this.props.userContext.scope)) {
        approveType = 'approvedFourAt'
      } else if(report.getTypeHasApproveFive() && report.getCanApproveFive(this.props.userContext.scope)) {
        approveType = 'approvedFiveAt'
      }

      if(approveType) {
        const formData = {
          [approveType]: new Date(),
          guid: r.reportGuid,
          comment: form.comment
        };
        return this.props.approveReport(formData)
          .then(() => {})
          .catch(() => {})
      } else {
        return Promise.resolve()
      }
    }))

    return promises.then(() => {
      this.setState({
        showApproveReportsDialog: false
      })
    });
  }

  reportReportState(report, i, phaseGuid) {
    return <div key={'report-status-' + phaseGuid + '-' + report.sequence + '-' + i} style={{textTransform: 'capitalize'}}>#{report.sequence}.{i + 1} {report.status.split('_').join(' ')}</div>
  }
  renderReportsState(reports, phaseGuid) {
    if(!reports) {
      return []
    }
    if(reports.length === 1) {
      return <div style={{textTransform: 'capitalize'}}>#{reports[0].sequence} {reports[0].status.split('_').join(' ')}</div>
    }
    return reports.map((r, i) => this.reportReportState(r, i, phaseGuid))
  }

  getLogGroup(report) {
    let logFields = report.layout.filter(field => field.schema === 'log-field');
    if(logFields) {
      let groups = logFields.reduce((g, lf) => [
        ...g,
        ...(Array.isArray(lf.groupBy)? lf.groupBy.filter(gb => gb !== null): lf.groupBy == null? [lf.groupBy]: []).map(gr => ({lf, g: gr}))
      ], [])

      //todo later support multiple groups
      if(groups.length) {
        let group = groups[0]
        let logFieldIndex = report.layout.findIndex(field => field === group.lf);
        let responses = report.responses[logFieldIndex]
        if(responses && responses.list && responses.list.length && responses.list[0] && responses.list[0][group.g]) {
          return responses.list[0][group.g].replace(/_/g, ' ')
        }
      }
    }

    return 'N/A'
  }

  getLogGroupLabel(reports) {
    let report = reports[reports.length - 1];
    let logFields = report.layout.filter(field => field.schema === 'log-field');
    let groups = logFields.reduce((g, lf) => [
      ...g,
      ...(Array.isArray(lf.groupBy)? lf.groupBy.filter(gb => gb !== null): lf.groupBy != null? [lf.groupBy]: [] ).map(gr => ({lf, g: gr}))
    ], [])

    //todo later support multiple groups
    if(groups.length) {
      let group = groups[0]
      try {
        return group.lf.fields[group.g].label
      } catch (ex) {
        return 'N/A'
      }
    }

    return 'N/A'
  }

  openReport(reportHash, index) {
    let reportAnalytics = this.props.reportAnalytics.find(analytics => analytics.reportAnalytics.reportMap[reportHash]);

    if (reportAnalytics) {
      let reports = reportAnalytics.reportAnalytics.reportMap[reportHash];

      if (reports && reports[index]) {
        ApiGet(`/api/v1/reports/${reports[index].reportGuid}`)
          .then(res => {
          this.props.reportClick(reportModel(res));
        })
      }
    }
  }

  getSequenceNumber(reports, key) {
    if (reports && reports.length) {
      if(reports.length === 1) {
        return (<Tooltip key={'tooltip-'  + key + '-' + reports[0].sequence}  tip={this.getLogGroup(reports[0])}><div onClick={() => this.openReport(key, 0)}>#{reports[0].sequence}</div></Tooltip>)
      }
      return reports.map((r, i) => (
        <Tooltip key={'tooltip-' + key + '-' + r.sequence + '-' + i} tip={this.getLogGroup(r)}><div onClick={() => this.openReport(key, i)}>#{r.sequence}.{i + 1}</div></Tooltip>
      ))
    }
    return <div style={{"color": "#fff"}}>#</div>
    // return (<div><div>);
  }

  removeOitReport(userId) {
    this.props.oitRemoved(userId);
  }

  exportReport(reportAnalytics, withComments) {
    this.setState({
      currentExport: reportAnalytics,
      showInlineComments: !!withComments
    }, () => {
      this.exportXls('export-table', reportAnalytics.user.getFullName().toLowerCase().split(' ').join('_'), withComments)
    })
  }

  async exportUnderPerformanceReport(reportAnalytics, formData) {
    this.setState({
      showUnderPerformanceReport: false
    })
    await taskDelay(350)
    let questions = this.props.filteredQuestions;
    let reportKeys = Object.keys(reportAnalytics.reportMap)
    let responses = this.getPhases(reportAnalytics.phases)
      .reduce((acc, phase) => [
        ...acc,
        ...reportKeys.filter(key => key.startsWith(phase.guid))
          .reduce((ac2, key) => [...ac2, ...reportAnalytics.reportMap[key].map(r => ({...r, phase}))], [])
      ], [])
      .reduce((acc, report) => {

        let responses = questions.reduce((ac2, q) => {
          let response = {...report.responsesMap[q]};

          if(response.rating === 'acceptable') {
            response.rating = 2
            response.ratingLabel = 'Acceptable: '
          }

          if(response.rating === 'unAcceptable') {
            response.rating = 1
            response.ratingLabel = 'Not Acceptable: '
          }
          if(response && (response.rating <= formData.score || response.notResponsive) && !response.notObserved && (response.comment || response.observationComment)) {
            return [
              ...ac2,
              {
                response,
                phase: report.phase,
                date: report.date,
                question: q
              }
            ]
          }
          return ac2
        }, [])

        return [
          ...acc,
          ...responses
        ]
      }, [])
      .reduce((acc, response) => ({
        ...acc,
        [response.question]: [
          ...(acc[response.question] || []),
          response
        ]
      }), {})


    let result = questions
      .filter(q => responses[q])
      .map(q => ({
        question: q,
        responses: responses[q]
      }))


    // console.log('exportUnderPerformanceReport', result)
    // let css = '@page { size: portrait; }';
    // this.style = document.createElement('style');
    // this.style.media = 'print';
    // this.style.appendChild(document.createTextNode(css));
    //
    // let head = document.head;
    // head.appendChild(this.style);

    // window.addEventListener('afterprint', this.afterPrint)
    // this.title = document.title;
    // document.title = `Performance report: ${this.state.reportAnalyticsForPerformanceReport.user.getFullName()}`
    // console.log('currentPrintPerformanceReport', result)

    try {
      let htmlToDocx = (await HTMLtoDOCX).default;
      this.setState({
        currentPrintPerformanceReport: result,
      }, () => {
        // setTimeout(() => {
        htmlToDocx(document.getElementById('performance-report').innerHTML, `
        <h1>${this.state.reportAnalyticsForPerformanceReport.user.getFullName()}</h1>
      `, {
          font: 'Arial'
        })
          .then((buffer) => {
            const pdfBlob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            const downloadUrl = URL.createObjectURL(pdfBlob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = `Performance report: ${this.state.reportAnalyticsForPerformanceReport.user.getFullName()}.docx`;
            link.click();
            URL.revokeObjectURL(downloadUrl);
          })
        // }, 1000)
      })
    } catch (ex) {
      console.log('ERR', ex)
    }

  }

  printReport(reportAnalytics) {
    window.addEventListener('afterprint', this.afterPrint)
    this.setState({
      currentPrint: reportAnalytics
    }, () => {
      window.print()
    })
  }

  afterPrint() {
    this.setState({
      currentPrint: null,
      currentPrintPerformanceReport: null,
      reportAnalyticsForPerformanceReport: null
    })
    if(this.title) {
      document.title = this.title
    }

    window.removeEventListener('afterprint', this.afterPrint)
    try {
      document.head.removeChild(this.style)
    } catch (ex) {}

  }

  exportXls(id, name) {
    var workbook = XLSX.utils.table_to_book(document.getElementById(id), {
      raw: true
    });
    Object.keys(workbook.Sheets['Sheet1'])
      .forEach(key => {
        let val = workbook.Sheets['Sheet1'][key];
        if(val.s && val.s.fill && val.v && val.v.length > 10) {
          val.s.alignment = {...(val.s.alignment || {}), wrapText: true}
        }

        workbook.Sheets['Sheet1'][key] = val
      })

    XLSX.writeFile(workbook, name + '.xlsx');
    this.setState({
      currentExport: null,
      showInlineComments: false
    })
  }

  getPhases(trainingPhases) {
    return trainingPhases
      .filter(tp => {
        if(this.state.openedDay) {
          return tp.guid === this.state.openedDay.phaseGuid
        }
        return this.props.selectedPhasesMap[tp.sequence]
      })
  }

  getWeeks(weeks, phase, reportAnalyticsObj) {
    if(this.state.openedDay) {
      return weeks.filter(w => w.weekNumber === this.state.openedDay.week)
    }
    if(this.props.departmentSettings.enablePtoAnalytics) {
      return weeks.filter(week => !!week.days.find(day => !!reportAnalyticsObj.reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`]))
    }
    return weeks
  }

  getDays(days, phase, week, reportAnalyticsObj) {
    if(this.state.openedDay) {
      return days.filter(d => d === this.state.openedDay.day)
    }

    if(this.props.departmentSettings.enablePtoAnalytics) {
      return days.filter(day => !!reportAnalyticsObj.reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`])
    }

    return days
  }

  getTotalPhaseTime(times) {

    if(!times) {
      return {}
    }
    let res =  times.reduce((acc, time) => ({
      total: parseInt(acc.total) + parseInt(time.total),
      segments: {
        ...acc.segments,
        ...time.segments.reduce((ac2, s) => ({
          ...ac2,
          [s.category]: parseInt(ac2[s.category] || 0) + parseInt(s.time)
        }),{})
      }
    }), {total: 0, segments: {}})
    return res;
  }

   displayedQuestion(reportAnalyticsObj) {
    if(this.props.compact && this.props.reportType === 'time-spend') {
      return this.props.filteredQuestions.filter(q => {
        return reportAnalyticsObj.reportAnalytics.totalAvgMap[`#${q}#`] && reportAnalyticsObj.reportAnalytics.totalAvgMap[`#${q}#`].timeSpendAvg > 0
      })
    }

    return this.props.filteredQuestions;
  }

  getAvgPerDay(reports, question) {
    let ratings = reports.map(r => {
      let q = r.responsesMap[question]
      if(!q) {
        return -1
      }
      if (q.rating === 'acceptable') {
        return 1;
      } else if (q.rating === 'unAcceptable') {
        return 0;
      } else if (q.rating) {
        return q.rating;
      } else if (q.notObserved) {
        return -1
      } else {
        return 0
      }
    }).filter(score => score > -1)
      .reduce((sum, score) => sum + score, 0)

    return (ratings/reports.length).toFixed(2)
  }

  renderCommentPopup(response, question, position) {
    return (
      <div
        className={classNames("rating-comment")}
        style={{
          top: position.top + 'px',
          left: position.left + 'px'
        }}
      >
        <div><i>{question.split(/(\r\n|\r|\n|\s-)/)[0]}</i></div>
        {response.isEvaluationRating ? (
          <Fragment>
            {getEvaluationComments(response).map(comment => (
              <Fragment key={comment.label}>
                <b>{comment.label}:</b>
                <div dangerouslySetInnerHTML={{__html: comment.comment}}></div>
              </Fragment>
            ))}
          </Fragment>
        ) : (
          <Fragment>
            {response.observationComment && (
              <Fragment>
                <b>Observation comment:</b>
                <div dangerouslySetInnerHTML={{__html: response.observationComment}}></div>
                {response.comment && <b>Comment:</b>}
              </Fragment>
            )}
            <div><b>Observation comment:</b></div>
            <div dangerouslySetInnerHTML={{__html: response.comment}}></div>
          </Fragment>
        )}
      </div>
    )
  }

  render() {
    return (
      <div className={classNames({
        'analytics-container': true,
        'fullscreen': this.state.isFullscreen
      })}
      >
        <div className="toggle-fullscreen" onClick={() => this.toggleFullscreen()}>
          <i className="fa fa-arrows-alt"/>
        </div>

        {this.props.reportAnalytics.map(reportAnalyticsObj => (
          <div key={reportAnalyticsObj.user.guid}>
            {reportAnalyticsObj.reportAnalytics && (
              <div className="analytics-report-container">
                <div>
                  <TimeAnalytics enableTimeChart={false} oitGuids={[reportAnalyticsObj.user.guid]}/>
                  <br/>
                </div>
                {!this.props.isSelf && <div className="user-name">
                  {reportAnalyticsObj.user.getFullName()}

                  <button className="button danger small"
                          onClick={() => this.removeOitReport(reportAnalyticsObj.user.guid)}>
                    <i className="fa fa-trash-o mr-2"/>
                    Remove
                  </button>

                  <button className="button edit small"
                          onClick={() => this.exportReport(reportAnalyticsObj)}>
                    <i className="fa fa-download mr-2"/>
                    Export
                  </button>
                  <button className="button edit small"
                          onClick={() => this.setState({
                              showUnderPerformanceReport: true,
                              reportAnalyticsForPerformanceReport: reportAnalyticsObj
                            })}>
                    <i className="fa fa-print mr-2"/>
                    Performance report
                  </button>
                  <button className="button edit small"
                          onClick={() => this.printReport(reportAnalyticsObj)}>
                    <i className="fa fa-print mr-2"/>
                    Print
                  </button>
                </div>}

                <AnalyticsGrid
                  reportAnalyticsObj={reportAnalyticsObj}
                  displayedQuestions={this.displayedQuestion(reportAnalyticsObj)}
                  compact={this.props.compact}
                  openedDay={this.state.openedDay}
                  reportType={this.props.reportType}
                  enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}
                  isApproveReportsLoading={this.state.isApproveReportsLoading}
                  popupPosition={this.state.popupPosition}
                  getPhases={this.getPhases.bind(this)}
                  getWeeks={this.getWeeks.bind(this)}
                  getDays={this.getDays.bind(this)}
                  getLogGroupLabel={this.getLogGroupLabel.bind(this)}
                  getSequenceNumber={this.getSequenceNumber.bind(this)}
                  getLogGroup={this.getLogGroup.bind(this)}
                  getBackgroundColor={this.getBackgroundColor.bind(this)}
                  getCellColor={this.getCellColor.bind(this)}
                  getCellValue={this.getCellValue.bind(this)}
                  renderCommentPopup={this.renderCommentPopup.bind(this)}
                  getAvgPerDay={this.getAvgPerDay.bind(this)}
                  getAvgCellValue={this.getAvgCellValue.bind(this)}
                  getAvgBackgroundColor={this.getAvgBackgroundColor.bind(this)}
                  getTotalTimeSpend={this.getTotalTimeSpend.bind(this)}
                  getPhaseTotalTimeSpend={this.getPhaseTotalTimeSpend.bind(this)}
                  getProgramTotalTimeSpend={this.getProgramTotalTimeSpend.bind(this)}
                  timeConvert={this.timeConvert.bind(this)}
                  openDay={this.openDay.bind(this)}
                  openApproveReports={this.openApproveReports.bind(this)}
                  renderReportsState={this.renderReportsState.bind(this)}
                  setPopupPosition={this.setPopupPosition.bind(this)}
                  closeOpenedDay={() => this.setState({openedDay: null})}
                />
              </div>
            )}
          </div>
        ))}
        {this.state.currentExport && (
          <table className="table-export" key={this.state.currentExport.user.guid} id={'export-table'}>
            <thead>
            <PhasesRow reportAnalytics={this.state.currentExport.reportAnalytics} enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}/>
            <WeeksRow reportAnalytics={this.state.currentExport.reportAnalytics} enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}/>
            <SequenceRow reportAnalytics={this.state.currentExport.reportAnalytics} enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}/>
            <DatesRow reportAnalytics={this.state.currentExport.reportAnalytics} enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}/>
            </thead>
            <tbody>
            {this.props.filteredQuestions.map(question => (
              <QuestionRow
                reportAnalytics={this.state.currentExport.reportAnalytics}
                question={question}
                reportType={this.props.reportType}
                showInlineComments={this.state.showInlineComments}
                enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}
              />
            ))}
            </tbody>
          </table>
        )}
        {this.state.currentPrint && (this.props.reportAnalytics.map(reportAnalyticsObj => (
          <div key={this.state.currentPrint.user.guid} className="table-report">
            <PhaseReport
              reportAnalytics={this.state.currentPrint.reportAnalytics}
              filteredQuestions={this.displayedQuestion(reportAnalyticsObj)}
              reportType={this.props.reportType}
              enablePtoAnalytics={this.props.departmentSettings.enablePtoAnalytics}
            />
          </div>
        )))}
        {this.state.currentPrintPerformanceReport && (
          <div key={'performance-report'} className="performance-report">
            <PerformanceReport
              currentPrintPerformanceReport={this.state.currentPrintPerformanceReport}
              reportAnalyticsForPerformanceReport={this.state.reportAnalyticsForPerformanceReport}
            />
          </div>
        )}

        <Modal isOpen={this.state.showApproveReportsDialog} onClose={() => this.setState({
          showApproveReportsDialog: false
        })}>
          <CustomForm
            config={ApproveReportsForm}
            submitAction={this.approveReports.bind(this)}
          />
        </Modal>

        <Modal isOpen={this.state.showUnderPerformanceReport} fullscreen={true} onClose={() => this.setState({
          showUnderPerformanceReport: false
        })}>
          {this.state.showUnderPerformanceReport &&
            <Fragment>
              <CustomForm
                config={ChooseRatingForm}
                onSubmit={(formData) => this.exportUnderPerformanceReport(this.state.reportAnalyticsForPerformanceReport.reportAnalytics, formData)}
              />
              <div style={{padding: '10px 30px 30px'}}>
                <p><small>If numbered rating is not used then choose "2" to include acceptable and not acceptable or choose "1" to filter out only not acceptable ratings</small></p>
              </div>
            </Fragment>}
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    departmentSettings: state.departmentSettings.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    approveReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.approveReport(formData))
    },
    rejectReport: (formData) => {
      dispatch(trainingPhasesActionCreators.rejectReport(formData))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsReport);
